// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__-NI+W","load8":"Spinner_load8__L7fVo"};